import React, { Fragment, useEffect } from "react";
import LazyLoad from "react-lazyload";
import { connect } from "react-redux";

import * as skillsActions from "../../../store/actions/skills";

import Typography from "../../atoms/Typography/Typography";
import Spinner from "../../atoms/Spinner/Spinner";
import Skill from "../../molecules/Skill/Skill";
import withErrorModal from "../../hoc/withErrorModal";

import "./Skills.scss";

const Skills = ({ loading, skills, onFetchSkills }) => {
  useEffect(() => {
    onFetchSkills();
  }, [onFetchSkills]);

  if (loading) {
    return <Spinner />;
  }

  return (
    <Fragment>
      {skills.map((category) => (
        <Fragment key={category.type}>
          <LazyLoad height={100} offset={100}>
            <Typography type="h3" className="skills-category-title">
              {category.type}
            </Typography>
            <div className="skills-category">
              {category.values.map((skill, index) => (
                <div key={index} className="skills-item">
                  <Skill level={skill.level}>{skill.name}</Skill>
                </div>
              ))}
            </div>
          </LazyLoad>
        </Fragment>
      ))}
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  skills: state.skillsRed.skills,
  loading: state.skillsRed.loading,
});

const mapDispatchToProps = (dispatch) => ({
  onFetchSkills: () => dispatch(skillsActions.fetchSkills()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorModal(Skills));
